import { render, staticRenderFns } from "./AdicionaNoCarrinho.vue?vue&type=template&id=7b89224f&scoped=true"
import script from "./AdicionaNoCarrinho.vue?vue&type=script&lang=js"
export * from "./AdicionaNoCarrinho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b89224f",
  null
  
)

export default component.exports